/// <reference path="../_all.ts" />

module editor {
  'use strict';

  export function EditorModalTemplate() : string {
    return `<md-dialog class="editor-cnt">
                        <md-toolbar class="md-menu-toolbar">
                            <div layout="row">
                              <md-toolbar-filler layout layout-align="center center">
                                <svg style="height: 45px; width: 42px;" ng-show="content.ContentMeta.Status == 2 && !vm.isTimed(content.ContentMeta)">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#topic-published"></use>
                                </svg>
                                <svg style="height: 45px; width: 42px;" ng-show="content.ContentMeta.Status == 1">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#topic-draft"></use>
                                </svg>
                                <svg style="height: 45px; width: 42px;" ng-show="content.ContentMeta.Status == 4">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#topic-deleted"></use>
                                </svg>
                                <svg style="height: 45px; width: 42px;" ng-show="content.ContentMeta.Status == 2 && vm.isTimed(content.ContentMeta)">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#topic-timed"></use>
                                </svg>
                                <svg style="height: 45px; width: 42px;" ng-show="content.ContentMeta.Status == 3">
                                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#topic-archived"></use>
                                </svg>
                              </md-toolbar-filler>

                              <div>
                                <h2 class="md-toolbar-tools">
                                  {{filter.FilterString2}}&nbsp;/&nbsp;
                                  {{filter.FilterString1}}
                                  <span ng-show="filter.FilterString2.Category != 14" ng-repeat="rpm in routeParameterStack">&nbsp;/&nbsp;{{rpm.DisplayName[currentLanguage.hlFull]}}</span>
                                  &nbsp;({{filter.IsLanguageIndifferent ? "ohne Sprache" : currentLanguage.hlFull}})
                                </h2>
                                <md-menu-bar>
                                  <md-menu>
                                    <button ng-click="$mdMenu.open()">
                                      Datei
                                    </button>
                                    <md-menu-content>
                                      <md-menu-item>
                                        <md-button ng-disabled="editorSession.getUndoManager().isClean() && ressourceEditForm.$pristine && metaEditForm.$pristine" ng-click="vm.saveContent(false)">
                                          Speichern
                                          <span class="md-alt-text">{{ 'M-S' | keyboardShortcut }}</span>
                                        </md-button>
                                      </md-menu-item>
                                      <md-menu-item>
                                        <md-button ng-disabled="editorSession.getUndoManager().isClean() && ressourceEditForm.$pristine && metaEditForm.$pristine" ng-click="vm.saveContent(true)">
                                          Speichern & Schliessen
                                        </md-button>
                                      </md-menu-item>
                                      <md-menu-divider></md-menu-divider>
                                      <md-menu-item>
                                        <md-button ng-disabled="content.ContentMeta.Status == 2 || content.ContentMeta.Status == 'undefined'" ng-click="changeStatus(2)">
                                          {{content.ContentMeta.Status == 2 ? 'Veröffentlicht' : 'Veröffentlichen'}}
                                        </md-button>
                                      </md-menu-item>
                                      <md-menu-item>
                                        <md-button ng-disabled="content.ContentMeta.Status == 1 || content.ContentMeta.Status == 'undefined'" ng-click="changeStatus(1)">
                                          {{content.ContentMeta.Status == 1 ? 'Entwurf' : content.ContentMeta.Status == 2 ? 'Veröffentlichung beenden' : 'In Entwurfsmodus setzen'}}
                                        </md-button>
                                      </md-menu-item>
                                      <md-menu-item>
                                        <md-button ng-disabled="content.ContentMeta.Status == 3 || content.ContentMeta.Status == 'undefined'" ng-click="changeStatus(3)">
                                          {{content.ContentMeta.Status == 3 ? 'Archiviert' : 'Archivieren'}}
                                        </md-button>
                                      </md-menu-item>
                                      <md-menu-item>
                                        <md-button ng-disabled="content.ContentMeta.Status == 4 || content.ContentMeta.Status == 'undefined'" ng-click="changeStatus(4)">
                                          {{content.ContentMeta.Status == 4 ? 'Gelöscht' : 'Löschen'}}
                                        </md-button>
                                      </md-menu-item>
                                      <md-menu-divider></md-menu-divider>
                                      <md-menu-item>
                                        <md-button ng-click="vm.closeDialog()">
                                          Schliessen
                                          <span class="md-alt-text">{{ 'ESC' | keyboardShortcut }}</span>
                                        </md-button>
                                      </md-menu-item>
                                    </md-menu-content>
                                  </md-menu>
                                  
                                  <md-menu>
                                    <button ng-click="$mdMenu.open()">     
                                      Sprache                                      
                                    </button>
                                    <md-menu-content>
                                      <md-menu-item ng-disabled="filter.IsLanguageIndifferent" type="radio" ng-model="settings.currentLanguage" ng-value="hl.hl" ng-repeat="hl in supportedLanguages | orderBy : 'hl'">{{hl.hlFull}}</md-menu-item>
                                    </md-menu-content>
                                  </md-menu>
                                  
                                  <md-menu>
                                    <button ng-click="$mdMenu.open()">
                                      Optionen
                                    </button>
                                    <md-menu-content>

                                      <md-menu-item type="radio" ng-model="settings.currentContentType" value="H" ng-model-options="{ getterSetter: true }">Html</md-menu-item>
                                      <md-menu-item type="radio" ng-model="settings.currentContentType" value="M" ng-model-options="{ getterSetter: true }">Markdown</md-menu-item>

                                      <md-menu-divider></md-menu-divider>

                                      <md-menu-item>
                                        <md-button ng-click="vm.editMeta('PageTitle')" ng-disabled="!vm.isMetaEditable(1)" >
                                          Page-Title Editieren
                                        </md-button>
                                      </md-menu-item>

                                      <md-menu-item>
                                        <md-button ng-click="vm.editMeta('MetaDescription')" ng-disabled="!vm.isMetaEditable(2)" >
                                          Meta-Description Editieren
                                        </md-button>
                                      </md-menu-item>

                                      <md-menu-item>
                                        <md-button ng-click="vm.updateTopics()">
                                          Beitragsliste aktualisieren
                                        </md-button>
                                      </md-menu-item>

                                      <md-menu-item>
                                        <md-button ng-click="vm.clearCache()">
                                          Cache leeren
                                          <span class="md-alt-text"> {{ 'M-l' | keyboardShortcut }}</span>
                                        </md-button>
                                      </md-menu-item>
                                      <md-menu-item>
                                        <md-button ng-click="vm.createMissingContent()">
                                          Fehlenden Inhalt erstellen.
                                        </md-button>
                                      </md-menu-item>
                                    </md-menu-content>
                                  </md-menu>

                                  <md-menu>
                                    <button ng-click="$mdMenu.open()">
                                      Templates
                                    </button>

                                    <md-menu-content>
                                      <md-menu-item class="md-indent" ng-repeat="fs1 in filterTree[14]">
                                        <md-menu>
                                          <md-button ng-click="$mdMenu.open()">{{fs1.name}}</md-button>
                                          <md-menu-content width="3">
                                            <md-menu-item ng-repeat="filter in fs1.templates">
                                              <md-button ng-click="vm.loadContent(filter)" title="{{filter.Description}}">
                                                {{filter.FilterString2}}
                                              </md-button>
                                            </md-menu-item>
                                          </md-menu-content>
                                        </md-menu>
                                      </md-menu-item>
                                    </md-menu-content>
                                  </md-menu>

                                  <md-menu>
                                    <button ng-click="$mdMenu.open()">
                                      Meldungen
                                    </button>

                                    <md-menu-content>
                                      <md-menu-item class="md-indent" ng-repeat="fs1 in filterTree[15]">
                                        <md-menu>
                                          <md-button ng-click="$mdMenu.open()">{{fs1.name}}</md-button>
                                          <md-menu-content width="3">
                                            <md-menu-item ng-repeat="filter in fs1.templates">
                                              <md-button ng-click="vm.loadContent(filter)" title="{{filter.Description}}">
                                                {{filter.FilterString2}}
                                              </md-button>
                                            </md-menu-item>
                                          </md-menu-content>
                                        </md-menu>
                                      </md-menu-item>
                                    </md-menu-content>
                                  </md-menu>


                                </md-menu-bar>
                              </div>
                            </div>
                          </md-toolbar>

                          <md-progress-linear md-mode="indeterminate" ng-disabled="!requestOnGoing"></md-progress-linear>

                          <md-nav-bar md-selected-nav-item="settings.view" nav-bar-aria-label="navigation links" ng-show="showRessources">
                            <md-nav-item md-nav-click="settings.view = 'Source'" name="Source">Quellcode</md-nav-item>
                            <md-nav-item md-nav-click="settings.view = 'Ressources'" ng-show="showRessources" name="Ressources">Ressourcen</md-nav-item>
                          </md-nav-bar>

                          <md-dialog-content style="" ng-show="settings.view == 'Source'">
                          <md-button class="md-fab md-mini nav-topic-button md-hue-1 md-primary" ng-show="showButton" aria-label="Open Topic Navigation" ng-click="vm.toggleLeft()">
                            <md-tooltip md-direction="bottom" md-z-index="1500">
                              Blog bearbeiten
                            </md-tooltip>
                            <svg class="svg-list-view-dims">
                              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#list-view"></use>
                            </svg>
                          </md-button>
                          <md-button class="md-fab md-mini nav-button md-hue-1 md-primary" ng-show="showButton" aria-label="Open MetaData Navigation" ng-click="vm.toggleRight()">
                            <md-tooltip md-direction="bottom" md-z-index="1500">
                              MetaData bearbeiten
                            </md-tooltip>
                            <svg>
                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#maschinen-metallindustrie"></use>
                            </svg>
                          </md-button>
                            <!-- https://ace.c9.io/build/kitchen-sink.html -->
                               <md-content layout="row" >   

                                  <md-sidenav class="md-sidenav-left topic-sidenav" md-component-id="left">
                                    <md-toolbar class="md-theme-light">
                                      <h4>Beiträge</h4>
                                      <md-button class="md-icon-button close" ng-click="vm.toggleLeft();" aria-label="Close Left Sidenav">
                                        <svg>
                                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#plus"></use>
                                        </svg>
                                      </md-button>
                                    </md-toolbar>

                                    <md-content>

                                      <div class="topic-filter" layout="row">
                                        <md-input-container flex="50">
                                          <md-select ng-model="topicStatusFltr" aria-label="Topic Status Filter">
                                            <md-option ng-selected="true" ng-value="0">Alle Beiträge</md-option>
                                            <md-option ng-value="1">Entwürfe</md-option>
                                            <md-option ng-value="2">Publizierte Beiträge</md-option>
                                            <md-option ng-value="3">Archivierte Beiträge</md-option>
                                          </md-select>
                                        </md-input-container>
                                        <md-input-container flex="50">
                                          <md-select ng-model="topicCategoryFltr" aria-label="Topic Category Filter" ng-change="topicTagFltr='all'">
                                            <md-option value="blog">Blog</md-option>
                                            <md-option value="verkaufshilfen">Verkaufshilfen</md-option>
                                            <md-option value="intranet">Intranet</md-option>
                                            <md-option value="events">Veranstaltungen</md-option>
                                          </md-select>

                                        </md-input-container>
                                      </div>
                                      <md-input-container>
                                        <md-select ng-model="topicTagFltr" aria-label="Topic Tag Filter" >
                                          <md-option ng-selected="true" value="all">Alle Tags</md-option>
                                          <md-option ng-value="tag.Name" ng-repeat="tag in allTags">{{tag._displayname}}</md-option>
                                        </md-select>
                                      </md-input-container>

                                      <md-list>
                                        <content-list-item content-data="topic" ng-hide="topic.ContentMeta.Status == 4" ng-repeat="topic in loadedTopics | statusTopic:topicStatusFltr | categoryTopic:topicCategoryFltr | tagTopic:topicTagFltr" ng-click="vm.loadContent(topic.ContentFilter)" title="{{topic.ContentMeta.Title}}">
                                        </content-list-item>
                                      </md-list>

                                      <md-button class="md-fab md-mini add-entry-button md-hue-1 md-primary" aria-label="Show Content Creation" ng-click="vm.newContent()">
                                        <md-tooltip md-direction="left" md-z-index="1500">
                                          Neuer Beitrag
                                        </md-tooltip>
                                        <svg>
                                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/res/svg/sprite.svg#plus"></use>
                                        </svg>
                                      </md-button>

                                    </md-content>                                    

                                  </md-sidenav>

                                  <div flex class="editor"
                                        ui-ace="{
                                          useWrapMode : true 
                                          , mode: 'html'
                                          , theme: 'xcode'
			                                    , onLoad : aceLoaded 
                                          , workerPath: '/library/public/ace/'
                                          , modePath: '/library/public/ace/'
                                          , themePath: '/library/public/ace/'
                                          , basePath: '/library/public/ace/'
                                        }"
                                        ng-model="content.Content" ng-model-options="{updateOn: 'default blur', debounce: {'default': 1000, 'blur': 0}}"> 
                                  </div>
                                  <div class="split-view-content" flex="50" ng-show="content.ContentType == 'M'">
                                    <img ng-src="{{vm.contentAttSrc(1)}}" ng-if="content.ContentMeta.Image" class="markdown-image">
                                    <div ng-bind-html="liveViewContent"></div>
                                  </div>
                                  


                                  <md-sidenav class="md-sidenav-right editor-sidenav" md-component-id="right">

                                    <md-nav-bar
                                          md-no-ink-bar="disableInkBar"
                                          md-selected-nav-item="page"
                                          nav-bar-aria-label="navigation links">
                                          <md-nav-item md-nav-click="" name="prop">
                                            Allgemein
                                          </md-nav-item>
                                          <md-nav-item md-nav-click="" name="visibility">
                                            Sichtbarkeit
                                          </md-nav-item>
                                          <md-nav-item md-nav-click="" name="seo" >
                                            SEO
                                          </md-nav-item>
                                    </md-nav-bar>



                                    <md-content>
                                      <form name="metaEditForm" class="sidenav-form">
                                        <div ng-show="page == 'prop'">

                                          <md-input-container>
                                            <label>Titel</label>
                                            <input name="title" ng-model="content.ContentMeta.Title" ng-model-options="{ debounce: 500 }" required>
                                            <div class="form-alert-message" ng-messages="metaEditForm.title.$error" role="alert">
                                              <div ng-message="required">Das Feld muss ausgefüllt werden</div>
                                            </div>
                                          </md-input-container>
                                          <md-input-container md-no-float>
                                            <label>URL</label>
                                            <input ng-model="content.ContentMeta.URL" placeholder="{{urlPlacehldr}}">
                                          </md-input-container>
                                          <!--<md-input-container>
                                            <label>Bild</label>
                                            <input ng-model="content.ContentMeta.Image">
                                          </md-input-container>-->
                                          <md-input-container>
                                            <label>Tags</label>
                                            <md-contact-chips
                                                ng-model="content.ContentMeta.Tags"
                                                md-contacts="vm.loadAllTags($query)"
                                                md-contact-name="_displayname"
                                                md-require-match="false"
                                                md-min-length="0"
                                                md-highlight-flags="i"
                                                placeholder="Tag">
                                            </md-contact-chips>
                                          </md-input-container>

                                          <md-input-container>
                                            <label>Bild (max. 2MB)</label>
                                            <div class="inputWrapper">
                                              <input type="file" ngf-select ng-model="picFile" name="image"    
                                                     id="submitImageInput" accept="image/*" ngf-max-size="2MB"
                                                     class="submitImageInput" ngf-model-invalid="errorFile" placeholder=" " ngf-ignore-invalid="'pattern maxSize'">
                                              <div ngf-drop ng-model="picFile" ngf-drag-over-class="'dragover-upload'" 
                                                   accept="image/*" ngf-pattern="'image/*'" ngf-multiple="false" class="drop-upload-container" 
                                                   ngf-max-size="2MB" ng-show="!content.ContentMeta.Image" ngf-ignore-invalid="'pattern maxSize'">
                                                <p>Drop image here</p>
                                              </div>
                                              <md-button id="submitImageButton" class="btn md-primary" ng-show="!content.ContentMeta.Image">Hochladen</md-button>
                                              <div ng-if="content.ContentMeta.Image">
                                                <img class="thumb" ng-src="{{vm.contentAttSrc(1)}}">
                                                <md-button class="btn" ng-click="vm.removeFile(1)">Löschen</md-button>
                                              </div>
                                            </div>
                                          </md-input-container>

                                          <md-input-container>
                                            <label>Anhang (max. 5MB)</label>
                                            <div class="inputWrapper">
                                              <input type="file" ngf-select ng-model="attFile" name="attachment"
                                                     id="submitAttachmentInput" accept="application/pdf" ngf-max-size="5MB"
                                                     class="submitAttachmentInput" ngf-model-invalid="errorFile" placeholder=" "  ngf-ignore-invalid="'pattern maxSize'"> 
                                              <div ngf-drop ng-model="attFile" ngf-drag-over-class="'dragover-upload'"
                                                   accept="application/pdf" ngf-pattern="'application/pdf'" ngf-multiple="false"
                                                   ngf-max-size="5MB" class="drop-upload-container" ng-show="!content.ContentMeta.Attachment"  ngf-ignore-invalid="'pattern maxSize'">
                                                <p>Drop attachment here</p>
                                              </div>

                                              <md-button id="submitAttachmentButton" class="btn md-primary" ng-show="!content.ContentMeta.Attachment">Hochladen</md-button>
                                              <div ng-if="content.ContentMeta.Attachment" layout="row">
                                                <md-button class="btn" ng-href="{{vm.contentAttSrc(2)}}">Download</md-button>
                                                <md-button class="btn" ng-click="vm.removeFile(2)">Löschen</md-button>
                                              </div>
                                            </div>
                                          </md-input-container>

                                        </div>











                                        <div ng-show="page=='visibility'">

                                            <md-input-container>
                                              <label>Permission</label>
                                              <md-select ng-model="content.ContentMeta.Permission">
                                                <md-option ng-repeat="p in permissionValues" ng-value="p.value">
                                                  {{p.text}}
                                                </md-option>
                                              </md-select>
                                            </md-input-container>

                                            <div class="sidenav-switches" style="margin-top: 40px;">
                                              <h4>Datum</h4>
                                              <div layout="row">
                                                  <md-switch flex="30" ng-model="isValidFromDateSet" ng-change="vm.initFromDate()">
                                                    Von
                                                  </md-switch>
                                                <md-datepicker flex="70" ng-model="validFromDate" md-placeholder="Anzeigen von" ng-disabled="!isValidFromDateSet"></md-datepicker>
                                              </div>
                                              <div layout="row">
                                                <md-switch flex="30" ng-model="isValidToDateSet" ng-change="vm.initToDate()">
                                                  Bis
                                                </md-switch>
                                                <md-datepicker flex="70" ng-model="validToDate" md-placeholder="Anzeigen bis" ng-disabled="!isValidToDateSet"></md-datepicker>
                                              </div>
                                              <p><i style="color: #BBB;">Beide Daten sind inkl. des gewählten Tages.</i></p>
                                            </div>


  
                                            <div class="sidenav-switches" layout="column" style="margin-top: 40px;">
                                              <md-switch flex="50" ng-model="content.ContentMeta.IsVisible">
                                                Sichtbar
                                              </md-switch>
                                              <p><i style="color: #BBB;">Nicht sichtbare Beiträge werden nicht gelistet, können jedoch direkt über die URL aufgerufen werden.</i></p>
                                              <md-switch flex ng-model="content.ContentMeta.IsFeatured">
                                                Featured
                                              </md-switch>
                                              <p><i style="color: #BBB;">Beiträge die gefeatured werden, erscheinen auf der Startseite, oben.</i></p>
                                            </div>
                                        </div>







                                        <div ng-show="page=='seo'">        

                                          <md-input-container>
                                            <label>MetaTitle</label>
                                            <input name="metaTitle" ng-maxlength="70" md-maxlength="70" ng-model="content.ContentMeta.MetaTitle">
                                            <div class="form-alert-message" ng-messages="metaEditForm.metaTitle.$error" role="alert">
                                              <div ng-message="maxlength">Meta Title zu lang</div>
                                            </div>
                                          </md-input-container>
                                          <md-input-container>
                                            <label>MetaDescription</label>
                                            <textarea name="metaDesc" ng-maxlength="160" md-maxlength="160" rows="5" ng-model="content.ContentMeta.MetaDescription"></textarea>
                                            <div class="form-alert-message" ng-messages="metaEditForm.metaDesc.$error" role="alert">
                                              <div ng-message="maxlength">Meta Description zu lang</div>
                                            </div>
                                          </md-input-container>
                                          <md-input-container>
                                            <label>Excerpt</label>
                                            <textarea name="excerpt" ng-maxlength="255" md-maxlength="255" rows="5" ng-model="content.Excerpt"></textarea>
                                            <div class="form-alert-message" ng-messages="metaEditForm.excerpt.$error" role="alert">
                                              <div ng-message="maxlength">Excerpt zu lang</div>
                                            </div>
                                          </md-input-container>

                                        </div>

                                      </form>
                                    </md-content>
















                                  </md-sidenav>
                               </md-content >
                          </md-dialog-content>



                          <md-dialog-content style="" ng-show="settings.view == 'Ressources'"  class="md-dense" ng-keydown="vm.OnKeyDown($event);">

                            <md-content>
                              <form name="ressourceEditForm" class="ressource-edit-form">

                                <md-subheader>
                                  <div layout="row">
                                    <div flex>
                                      Key
                                    </div>
                                    <div flex >
                                      Beschreibung
                                    </div>
                                    <div flex ng-repeat="hl in supportedLanguages | orderBy : 'hl'">
                                      {{hl.hlFull}}
                                    </div>
                                  </div>
                                </md-subheader>


                                <div layout="row" ng-repeat="r in ressourceData" layout-padding>

                                  <div flex title="{{r.Scope}}">
                                    <md-input-container  class="md-block" md-no-float>
                                      <label>{{r.Key}}</label>
                                    </md-input-container>
                                  </div>

                                  <div flex>
                                    <md-input-container  class="md-block" md-no-float>
                                      <input ng-model="r.Desc" placeholder="Beschreibung">
                                    </md-input-container>
                                  </div>

                                  <div flex ng-repeat="hl in supportedLanguages | orderBy : 'hl'">
                                    <md-input-container class="md-block" md-no-float>
                                      <input ng-model="r.Text[hl.hl]" placeholder="Text in {{hl.hlFull}}">
                                    </md-input-container>
                                  </div>

                                </div>                                
                              </form>

                            </md-content>
                                  
                          </md-dialog-content>
        
                        <md-dialog-actions>
                            <span style="margin-right: 20px;"><a href="https://github.com/ajaxorg/ace/wiki/Default-Keyboard-Shortcuts" target="_blank">Tastenkombinationen</a></span>
                            <span class="flex"><a href="https://www.heise.de/mac-and-i/downloads/65/1/1/6/7/1/0/3/Markdown-CheatSheet-Deutsch.pdf" target="_blank">Formatierung</a></span>

                            <!-- {{settings.currentLanguage | json}} -->
                            <span class="message" ng-show="showSaveSuccess">Erfolgreich gespeichert.</span>
                            <span class="message" ng-show="showCacheSuccess">Cache erfolgreich geleert.</span>
                            <span class="message" ng-show="showSaveInProgress">Speichern…</span>
                            <span class="message" ng-show="message">{{message}}</span>

                        </md-dialog-actions>

                    </md-dialog>`;
  }
}